<div class="charts-container position-relative">
  <div class="day-chart">
    <canvas [id]="chartIdPrefix + '-0'" style="height: 240px;"></canvas>
  </div>

  <div class="legend-container mt-2 d-flex justify-content-center align-items-center flex-wrap gap-3">
    <div class="sun-item">
      <i class="fas fa-sun text-warning me-1"></i>
      <span class="sun-label">{{ 'sunrise' | translate }} ({{ 'today' | translate }}):</span>
      <span class="sun-time">{{ sunriseLabel }}</span>
    </div>
    <div class="sun-item">
      <i class="fas fa-moon text-muted me-1"></i>
      <span class="sun-label">{{ 'sunset' | translate }} ({{ 'today' | translate }}):</span>
      <span class="sun-time">{{ sunsetLabel }}</span>
    </div>
    <div class="sun-item" *ngIf="hasAstcalData">
      <i class="fas fa-sun text-muted me-1"></i>
      <span class="sun-label">{{ 'correctionSunrise' | translate }}:</span>
      <span class="sun-time">{{ formatSunCorrection(sunriseCorrectionMinutes) }}</span>
    </div>
    <div class="sun-item" *ngIf="hasAstcalData">
      <i class="fas fa-moon text-muted me-1"></i>
      <span class="sun-label">{{ 'correctionSunset' | translate }}:</span>
      <span class="sun-time">{{ formatSunCorrection(sunsetCorrectionMinutes) }}</span>
    </div>
  </div>
</div>
